module.exports = __webpack_public_path__ + "fonts/SanFranciscoDisplay-Bold.57ae74ba.woff";